import Gallery from "../components/elements/Gallery";
import GalleryPreview from "../components/elements/GalleryPreview";
import DistillationCatalog from "../components/catalog/DistillationCatalog";
import Rate from "../components/elements/Rate";
import PopularArticle from "../components/elements/PopularArticle";
import MainPageArticles from "../components/elements/MainPageArticles";

if (document.getElementById('gallery')) {
    new Vue({
        el: '#gallery',
        components: {
            Gallery
        },
    });
}

if (document.getElementById('gallery-preview')) {
    new Vue({
        el: '#gallery-preview',
        components: {
            GalleryPreview
        },
    });
}

if (document.getElementById('distillation-catalog')) {
    new Vue({
        el: '#distillation-catalog',
        components: {
            DistillationCatalog
        },
    });
}

if (document.getElementById('rate')) {
    new Vue({
        el: '#rate',
        components: {
            Rate
        },
    });
}

if (document.getElementById('popular-article')) {
    new Vue({
        el: '#popular-article',
        components: {
            PopularArticle
        },
    });
}

if (document.getElementById('main-page-articles')) {
    new Vue({
        el: '#main-page-articles',
        components: {
            MainPageArticles
        },
    });
}


// WEBPACK FOOTER //
// ./resources/js/snippets/elements.js